import { useDisplay } from "vuetify";

export function useSidebarStore() {
  const collapsed = useState("sidebar-collapsed", () => false);
  const tempOpen = useState("sidebar-temp-open", () => false);
  const { mobile: isMobile } = useDisplay();

  if (import.meta.client) {
    collapsed.value = localStorage.getItem("sidebar_collapsed") === "true";
  }

  watch(collapsed, () => {
    if (import.meta.client) {
      localStorage.setItem("sidebar_collapsed", String(collapsed.value));
    }
  });
  return { collapsed, tempOpen };
}
